import { extend, withValidation, validate } from 'vee-validate';

const kExtend = extend;
const kWithValidation = withValidation;
const kValidate = validate;


export {
  kExtend, kWithValidation, kValidate
};